/**
 * Centralized debug mode management
 * 
 * This composable controls debug features across the entire application
 * and allows for temporary overrides of production behavior.
 * 
 * To disable debug mode in production:
 * 1. Set FORCE_DEBUG_MODE to false below
 * 2. OR: Set forceDebugMode = false in localStorage
 */

// TEMPORARY OVERRIDE - SET TO FALSE TO DISABLE DEBUG IN PRODUCTION
const FORCE_DEBUG_MODE = true;

export const useDebugMode = () => {
    // Function to check if we should enable debug mode
    const isDebugMode = () => {
        if (process.server) {
            // On server, only use NODE_ENV
            return process.env.NODE_ENV !== 'production';
        }
        
        // Check for localStorage override if in browser
        if (process.client) {
            const localStorageOverride = localStorage.getItem('forceDebugMode');
            if (localStorageOverride !== null) {
                return localStorageOverride === 'true';
            }
        }
        
        // Use the temporary override for production or NODE_ENV for development
        return process.env.NODE_ENV !== 'production' || FORCE_DEBUG_MODE;
    };
    
    // Toggle the debug mode via localStorage
    const toggleDebugMode = () => {
        if (process.client) {
            const current = localStorage.getItem('forceDebugMode') === 'true';
            localStorage.setItem('forceDebugMode', (!current).toString());
            // Force page reload to apply the changes
            window.location.reload();
        }
    };
    
    // Set a specific debug mode value
    const setDebugMode = (value: boolean) => {
        if (process.client) {
            localStorage.setItem('forceDebugMode', value.toString());
            // Force page reload to apply the changes
            window.location.reload();
        }
    };
    
    return {
        isDebugMode,
        toggleDebugMode,
        setDebugMode
    };
}; 